import React from 'react';
import styled from 'styled-components';
import { Box } from '@components/layout/Grid';
import Icon from './Icon';

const Element = styled.button`
  display: inline-flex;
  align-items: center;
  color: ${({ isSelected }) => (isSelected ? '#fff' : '#6b6f81')};
  font-size: 12px;
  font-weight: 300;
  border-radius: 3px;
  padding: 5px;
  border: ${({ isSelected }) => (isSelected ? 'none' : '1px solid #eeeeee')};
  outline: none;
  background-color: ${({ isSelected }) => (isSelected ? '#88bfbd' : '#fff')};
  transition: color 300ms ease-in, border 200ms ease-in,
    background-color 300ms ease-out;
  cursor: pointer;

  &:hover {
    border: ${props => (props.isSelected ? 'none' : '1px solid #c3c3c3')};
  }

  i {
    margin-left: 5px;
  }
`;

const Tag = props => {
  return (
    <Element
      onClick={props.onClick}
      isSelected={props.isSelected}
      important={props.important}
      data-taxonomy={props.taxonomy}
      data-term={props.term}
    >
      <Box>{props.children}</Box>
      {props.isSelected ? <Icon name="ygb-icon-close" fontSize="8px" /> : null}
    </Element>
  );
};

export default Tag;
